import { AHText, AHTextFonts, Box } from "arkh";
import React, { useEffect, useRef } from "react";
import Animated, {
  Easing,
  interpolate,
  useAnimatedStyle,
  useSharedValue,
  withTiming,
} from "react-native-reanimated";

import { FormattedMessage } from "react-intl";
import { useKeyboardInModal } from "./useKeyboardInModal";
import { Lottie, LottieRef } from "../../components/Lottie";

export const SearchListInstructions = () => {
  const [keyboardBottomInset, { onLayout }] = useKeyboardInModal();
  const ref = useRef<LottieRef>(null);
  useEffect(() => {
    ref.current?.play();
  }, []);
  const animation = useSharedValue(0);

  useEffect(() => {
    animation.value = withTiming(1, {
      duration: 700,
      easing: Easing.out(Easing.ease),
    });

    return () => {
      animation.value = 0;
    };
  }, [animation]);

  const animatedStyle = useAnimatedStyle(() => ({
    flex: 1,
    opacity: interpolate(animation.value, [0, 1], [0, 1]),
  }));

  return (
    <Box
      style={{ flex: 1, paddingBottom: keyboardBottomInset }}
      onLayout={onLayout}
    >
      <Animated.View style={animatedStyle}>
        <Box spaceHorizontal="large" spaceTop="xlarge">
          <AHText
            type="title"
            spaceBottom="small"
            style={{ textAlign: "center" }}
          >
            <FormattedMessage
              description="Files Search Empty Intro Title"
              defaultMessage="Start typing to search for files!"
            />
          </AHText>
          <AHText
            type="title"
            color="washedText"
            font={AHTextFonts.REGULAR}
            style={{ textAlign: "center" }}
          >
            <FormattedMessage
              description="Files Search Empty Intro SubTitle"
              defaultMessage="You can also search for the contents of files!"
            />
          </AHText>
        </Box>
        <Box style={{ flex: 1 }}>
          <Lottie
            ref={ref}
            source={require("./searching.json")}
            autoPlay
            loop
            speed={1}
            hardwareAccelerationAndroid
          />
        </Box>
      </Animated.View>
    </Box>
  );
};
